import { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import Header from "./Header";
// import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel, { Dots } from '@brainhubeu/react-carousel';
import Card from "../components/Card";
import { changeLayout, setImage, setBackupImage } from "../reducers/actions";
import '@brainhubeu/react-carousel/lib/style.css';
import { IoPersonCircleOutline, IoImageOutline, IoAlertCircleOutline } from 'react-icons/io5';

class Step1 extends Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleImage = this.handleImage.bind(this);
    this.renderNextButton = this.renderNextButton.bind(this);
    this.renderImage = this.renderImage.bind(this);
  }

  handleChange(index) {
    this.props.changeLayout(index);
  }

  handleImage(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    const formData = new FormData();
    formData.append('files', file);

    fetch('/designer/upload', {method: 'POST', body: formData, mode: 'no-cors'})
      .then((res) => {
        const json = res.json();

        return json;
      }).then(json => {
        this.props.setBackupImage(json.url);
      })
      .catch((err) => {

      });

    reader.onloadend = () => {
      this.props.setImage(file, reader.result);
    }

    reader.readAsDataURL(file)
  }

  renderNextButton() {
    if (this.props.previewUrl) {
      return <Link to={`${process.env.PUBLIC_URL}/step2`} className="btn btn-primary">次へ: テキストの入力</Link>;
    }

    return <button className="btn btn-primary" disabled>次へ: テキストの入力</button>;
  }

  renderImage() {
    if (this.props.previewUrl) {
      return (
        <img className="t-image" src={this.props.previewUrl} alt="アップロードされた写真" />
      );
    }

    return (
      <div className="t-image-placeholder"><IoPersonCircleOutline /></div>
    );
  }

  render() {
    let width = 220;

    if (window.innerWidth <= 375) {
      width = 180;
    }

    return (
      <div className="t-mobile-container">
        <Header />
        <div className="t-main">
          <div className="t-alert">
            <span className="t-secondary-title">STEP1</span> レイアウト選択と顔写真アップロード
          </div>

          <div className="t-main-carousel">
            <Carousel value={this.props.currentLayout} onChange={this.handleChange} plugins={['arrows']}>
              {this.props.layouts.map((layout, i) => (
                <div className=".t-carousel-item" key={i}>
                  <Card
                    objects={layout.objects}
                    width={width}
                    sample={true}
                  />

                  <div className="text-center mt-2">
                    <span className="t-carousel-legend">{layout.name}</span>
                  </div>

                </div>
              ))}
            </Carousel>
          </div>


        </div>
        <div className="t-secondary">
          <div className="t-image-upload">
            <div className="t-image-upload-title">
              顔写真のアップロード
            </div>
            <div className="t-image-upload-content">
              <div className="t-image-upload-preview">
                {this.renderImage()}
              </div>
              <div className="t-image-upload-form">
                <p><IoAlertCircleOutline /> 顔の切り抜き加工は弊社で行います</p>
                <div className="t-image-upload-trigger">
                  <div className="t-image-upload-dummy">
                    <IoImageOutline /> 画像を選択する
                  </div>
                  <input className="form-control" type="file" name="image" accept="image/*" onChange={this.handleImage} />
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="t-footer">
          <div className="t-footer-actions">
            {this.renderNextButton()}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(f => f, {changeLayout, setImage, setBackupImage})(Step1);